/* eslint-disable prefer-destructuring */
import styled from "styled-components";
import * as CommonPaymentDetails from "../../../../../../../common-deprecated/styles/toyota/basket/PaymentDetails";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as MonthlyPrice from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import * as CashPrice from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";

export const Wrapper = styled(CommonPaymentDetails.Wrapper)`
    dt,
    dd {
        margin-bottom: 0;
    }
    ${MonthlyPrice.Text} {
        font-size: 1.5rem;
        color: ${theme.colors.primaryBlack};
    }

    ${CashPrice.Text} {
        font-size: 1.5rem;
        color: ${theme.colors.primaryBlack};
    }
`;

export const RegularText = CommonPaymentDetails.RegularText;

export const MonthlyRateDisclaimer = CommonPaymentDetails.MonthlyRateDisclaimer;

export const DisclaimerWrapper = CommonPaymentDetails.DisclaimerWrapper;
